import React from 'react';
import classNames from 'classnames';
import Icons from '../../../components/Icons/Icons';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import css from './SharedComponents.module.css';
import { PrimaryButtonInline } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import {
  bulkJobsListingsSelector,
  closeListing,
  singleJobsListingsSelector,
} from '../ListingPage.duck';
import { FormattedMessage } from 'react-intl';
import { getTimeAgo, isArrayLength } from '../../../util/genericHelpers';
import { formatMoney } from '../../../util/currency';
import { useListingPageContext } from '../context/ListingPageContext';
import ListingPageActionButtons from '../ListingPageActionButtons';
import { EDIT, JOB_POST } from '../../../util/constants';
import { createResourceLocatorString } from '../../../util/routes';
import { createSlug } from '../../../util/urlHelpers';
import { sliderSettings } from '../../../util/sliderSettings';

const Step = ({
  listing,
  intl,
  isOwnListing,
  dispatch,
  history,
  routeConfiguration,
  profileImageIcon,
  isCurrentUserLinkedToListing,
}) => {
  const { title = '', publicData = {}, price = {}, createdAt } = listing?.attributes || {};
  const { tasks, parentListingTitle } = publicData;
  const formattedMoney = price && formatMoney(intl, price);

  const handleEdit = () => {
    history.push({
      pathname: createResourceLocatorString(
        'EditJobPostPage',
        routeConfiguration,
        { id: listing?.id?.uuid, slug: createSlug(title), type: EDIT },
        {}
      ),
      state: { isEditJobPostPage: true },
    });
  };

  const handleDelete = async () => {
    try {
      await dispatch(closeListing(JOB_POST, listing?.id?.uuid));
    } catch (error) {
      console.error('Error deleting listing:', error);
    }
  };

  return (
    <div className={css.couponBlock}>
      <div className={css.blockTopInfo}>
        <div className={css.offerNameSec}>
          <div className={css.offerImgSec}>
            <img src={profileImageIcon} alt={title || 'job listing'} />
          </div>
          <div className={classNames(css.offerInfoSec, css.favoriteSec)}>
            {parentListingTitle && <h3>{parentListingTitle}</h3>}
            <h3>{title}</h3>
            {tasks && <p>{tasks}</p>}
          </div>
        </div>
        <div className={css.jobDescription}></div>
      </div>
      <div className={css.blockBottomInfo}>
        {formattedMoney && (
          <div className={css.blockInfoLeft}>
            <div className={css.blockInfo}>
              <p className={css.price}>{formattedMoney}</p>
            </div>
          </div>
        )}
        {isCurrentUserLinkedToListing && (
          <div className={css.blockInfoLeft}>
            <PrimaryButtonInline className={css.applyBtn}>
              <FormattedMessage id="RenderJobPost.applyNow" />
            </PrimaryButtonInline>
          </div>
        )}
        <div className={css.blockInfoLeft}>
          <Icons name="clock" />
          {createdAt && (
            <div className={css.blockInfo}>
              <span>{getTimeAgo(createdAt)}</span>
            </div>
          )}
        </div>
      </div>
      {isOwnListing && (
        <ListingPageActionButtons
          listingId={listing?.id?.uuid}
          handleDelete={handleDelete}
          handleEdit={handleEdit}
        />
      )}
    </div>
  );
};

const JobSection = ({ titleId, listings, props }) => {
  const {
    intl,
    profileImageIcon,
    isOwnListing,
    history,
    routeConfiguration,
    dispatch,
    isCurrentUserLinkedToListing = false,
  } = props;
  if (!isArrayLength(listings)) {
    return null;
  }

  return (
    <div className={classNames(css.talentOptions, css.brandPostings)}>
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>
              <FormattedMessage id={titleId} />
            </h2>
          </div>
        </div>
        <div className={css.sectionContent}>
          <div className={css.brandCouponSec}>
            <Slider {...sliderSettings}>
              {listings.map(listing => (
                <Step
                  key={listing?.id?.uuid}
                  listing={listing}
                  intl={intl}
                  isOwnListing={isOwnListing}
                  dispatch={dispatch}
                  history={history}
                  profileImageIcon={profileImageIcon}
                  routeConfiguration={routeConfiguration}
                  isCurrentUserLinkedToListing={isCurrentUserLinkedToListing}
                />
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

const RenderJobPost = props => {
  const dispatch = useDispatch();
  const singleJobListings = useSelector(singleJobsListingsSelector);
  const bulkJobListings = useSelector(bulkJobsListingsSelector);
  const { isOwnListing, history, routeConfiguration } = useListingPageContext();
  return (
    <>
      <JobSection
        titleId="RenderJobPost.singleJobsTitle"
        listings={singleJobListings}
        props={{ ...props, isOwnListing, history, routeConfiguration, dispatch }}
      />
      <JobSection
        titleId="RenderJobPost.bulkJobsTitle"
        listings={bulkJobListings}
        props={{ ...props, isOwnListing, history, routeConfiguration, dispatch }}
      />
    </>
  );
};

export default RenderJobPost;
